'use client';
import * as Styled from './styled';
import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';
import { TRenderAsEnum } from '../../DataGrid/lib';

const formatValue = (field: any, value: string) => {
  switch (field.dtype) {
    case 'f64':
    case 'f32':
      return Number(value).toFixed(6);
    default:
      return value;
  }
};

const DetailsEditor: React.FC<{ value: string | undefined; onChange: (value: number | null) => void }> = ({
  value,
  onChange,
}) => {
  const getReturnValue = (value: string) => {
    if (isNaN(parseFloat(value))) {
      return null;
    } else {
      return parseFloat(value);
    }
  };

  return (
    <input
      type="number"
      value={value?.toString() || ''}
      placeholder="NULL"
      onChange={(e) => onChange(getReturnValue(e.target.value))}
      style={{ width: '100%', padding: 10, border: 'none', background: 'none' }}
    />
  );
};

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    rootPath?: string;
    value: string | number | undefined;
    onChange?: (value: number | null) => void;
  }
> = ({ field, rootPath, value, onChange, ...rest }) => {
  return onChange ? (
    <DetailsEditor value={value?.toString()} onChange={onChange} />
  ) : (
    <Styled.Details {...rest}>
      {value === null || value === undefined ? (
        <span className="null-value">NULL</span>
      ) : (
        formatValue(field, value?.toString())
      )}
    </Styled.Details>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: string; renderAs: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  const displayValue = renderAs === 'float' ? Number(value).toFixed(6) : value;
  return (
    <Styled.Cell {...rest}>
      <span>{displayValue}</span>
    </Styled.Cell>
  );
};

export const Header: React.FC<RenderHeaderCellProps<any> & { children: React.ReactNode }> = ({ children, ...rest }) => {
  const field = rest.column as ColumnWithDType;
  const displayName = field.name === '_oxen_row_id' ? '(idx)' : field.name;
  return (
    <Styled.Header>
      <div className="header-cell-name">{displayName}</div>
      {children}
    </Styled.Header>
  );
};
